/**
 *  nsMobilePhoneNumber will throw a nsMobilePhoneNumber validation error for the field
 *
 *  Usage: ns-mobile-phone-number="name of mobile phone prefix"
 *     ex: ns-mobile-phone-number='shippingMobilePrefix'
 */
import {utilModule} from '../module.js';

utilModule.directive('nsMobilePhoneNumber', function() {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {
            let modelPath   = attr.ngModel.substr(0,attr.ngModel.lastIndexOf("."));
            // Read the name of the shippingMobilePrefix model property
            let shippingMobilePrefixString = modelPath + "." + attr.nsMobilePhoneNumber;
            let shippingMobilePhoneNumberString = attr.ngModel;

            ele.bind('blur', function() {
                scope.$apply(function() {
                    ele[0].value = ele[0].value.replace(/[^0-9]/g, '');
                });
            });

            scope.$watch(shippingMobilePrefixString, function() {
                checkPhoneNumber();
            });

            scope.$watch(shippingMobilePhoneNumberString, function() {
                checkPhoneNumber();
            });

            function checkPhoneNumber() {
                let shippingMobilePrefixStringValue =  scope.$eval(shippingMobilePrefixString),
                    shippingMobilePhoneNumberStringValue = ele[0].value;
                if (shippingMobilePrefixStringValue == 'HU+36' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'SK+421' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'CZ+420' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'PL+48' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'RO+40' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'TR+90' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'UK+44' && shippingMobilePhoneNumberStringValue.length != 11
                    || shippingMobilePrefixStringValue == 'IE+353' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'DE+49' && (shippingMobilePhoneNumberStringValue.length < 9 || shippingMobilePhoneNumberStringValue.length > 13)
                    || shippingMobilePrefixStringValue == 'AT+43' && (shippingMobilePhoneNumberStringValue.length < 10 || shippingMobilePhoneNumberStringValue.length > 12)
                    || shippingMobilePrefixStringValue == 'CH+41' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'IT+39' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'SE+46' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'DK+45' && shippingMobilePhoneNumberStringValue.length != 8
                    || shippingMobilePrefixStringValue == 'NO+47' && shippingMobilePhoneNumberStringValue.length != 8
                    || shippingMobilePrefixStringValue == 'FI+358' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'IS+354' && shippingMobilePhoneNumberStringValue.length != 7
                    || shippingMobilePrefixStringValue == 'IL+972' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'ZA+27' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'RU+7' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'UA+38' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'BE+32' && shippingMobilePhoneNumberStringValue.length != 10
                    || shippingMobilePrefixStringValue == 'PT+351' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'ES+34' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'NL+31' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'FR+33' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'LU+352' && shippingMobilePhoneNumberStringValue.length != 9
                    || shippingMobilePrefixStringValue == 'US+1' && shippingMobilePhoneNumberStringValue.length != 10
                ) {
                    ctrl.$setValidity('nsMobilePhoneNumber', false);
                } else {
                    ctrl.$setValidity('nsMobilePhoneNumber', true);
                }
            }
        }
    };
});
